import React, { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import '../css/Survey.css'; // Import your CSS file
import GoToTopButton from '../pages/GoToTopButton';
import ScrollProgressBar from 'react-scroll-progress-bar';
import { Link } from 'react-router-dom';



// Import all the images
import i1 from '../graph-img/i1.png';
import i2 from '../graph-img/i2.png';
import i3 from '../graph-img/i3.png';
import i4 from '../graph-img/i4.png';
import i5 from '../graph-img/i5.png';
import i6 from '../graph-img/i6.png';
import i7 from '../graph-img/i7.png';
import i8 from '../graph-img/i8.png';
import i9 from '../graph-img/i9.png';
import i10 from '../graph-img/i10.png';
import i11 from '../graph-img/i11.png';
import i12 from '../graph-img/i12.png';
import i13 from '../graph-img/i13.png';
import i14 from '../graph-img/i14.png';
import i15 from '../graph-img/i15.png';
import i16 from '../graph-img/i16.png';


const Survey = () => {
  const [isNavVisible, setIsNavVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    if (prevScrollPos > currentScrollPos) {
      setIsNavVisible(true);
    } else {
      setIsNavVisible(false);
    }
    prevScrollPos = currentScrollPos;
  };

  let prevScrollPos = window.pageYOffset;

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="my-unique-survey">
      <ScrollProgressBar height="4px" color="#007bff" duration="0.2" />
      <GoToTopButton />
      <Tabs
        defaultActiveKey="pre"
        id="fill-tab-example"
        className={`mb-3 ${isNavVisible ? '' : 'hidden-nav'}`}
        fill
      >
        <Tab eventKey="pre" title={<span className="my-title">Pre-Survey</span>}>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdgz-YJjJyyMdmyZ_KWbvQj9ogJgnEEriYy1o_Iy9LTQ-e4Mw/viewform?embedded=true" width="940" height="4845" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
          
        </Tab>

        <Tab eventKey="result" title={<span className="my-title">Survey Result</span>}>
          <br /><br />
          <button class="excel-button">
              <Link to="/excel" class="excel-link">View in Excel</Link>
          </button>

          <div className="servey-result-img">
         
            <img src={i1} alt="img1" />
            
            <img src={i2} alt="img2" />
            <img src={i3} alt="img3" />
            <img src={i4} alt="img4" />
            <img src={i5} alt="img5" />
            <img src={i6} alt="img6" />
            <img src={i7} alt="img7" />
            <img src={i8} alt="img8" />
            <img src={i9} alt="img9" />
            <img src={i10} alt="img10" />
            <img src={i11} alt="img11" />
            <img src={i12} alt="img12" />
            <img src={i13} alt="img13" />
            <img src={i14} alt="img14" />
            <img src={i15} alt="img15" />
            <img src={i16} alt="img16" />
          </div>
          <br /><br />
        </Tab>

        <Tab eventKey="post" title={<span className="my-title post-servey-cls">Post-Survey</span>}>
       
          
        <p>
            This page is currently under maintenance and will be updated in the coming days. We appreciate your patience and invite you to check back soon for the latest information.
          </p>
          <button className="go-back-button-maintain" onClick={() => window.history.back()}>Go Back</button>  
          


        </Tab>


      </Tabs>
    </div>
  );
};

export default Survey;
